<div class="stage-header-wrapper">
    <threedot-navigation [dwelling]="projectStage()" [newDwellingProject]="projectInfo()"
        [publications]="publications()" [mapMode]="mapMode()"></threedot-navigation>

    @if( projectStage() != null) {

    <h1>
        <!-- <span class="estate-type-icon" [class]="estateTypeCssClass()"></span> -->
        @if(projectStage().saleStateType === EVNDSaleStateType.Withdrawn) {
        <span class="withdrawn">Trukket</span>
        }
        {{ projectStage().stageName }}
    </h1>

    @if(!mapMode()) {
    <div class="infographics mobile">
        <div class="circular-progress">
            <ev-circular-progress [size]="'113px'" [strokeWidth]="10" [maxValue]="projectStage().numUnits"
                [strokeColor]="projectStage().numberSold === projectStage().numUnits ? colorGreen15 : colorBlue20"
                [value]="projectStage().numberSold">
                <div class="circular-progress-inner-content">
                    <div class="toptext">{{ percentSold() }}%</div>
                    <div class="undertext">solgt</div>
                    <div class="subtext">{{ projectStage().numberSold }} av {{ projectStage().numUnits }}</div>
                </div>
            </ev-circular-progress>
        </div>
    </div>
    }
    } @else if(!stageMode()) {
    <h1>
        {{ projectInfo()?.projectName }}
    </h1>
    @if(!mapMode()) {
    <div class="infographics mobile">
    </div>
    }
    } @else {
    <h1 class="title-placeholder">&nbsp;</h1>
    }

</div>


@if((projectStage() != null || stageMode()) && !mapMode()) {
<div class="links desktop">
    @if(cadastre() != null) {
    <div class="cadastre">
        <div class="cadastre-info">{{cadastre()}}</div>
        <div class="information-icon" (clickOutside)="cadastreDialogVisible = false"
            (click)="cadastreDialogVisible = !cadastreDialogVisible"></div>

        <ev_tooltip (close)="cadastreDialogVisible = false" [zIndex]="2000" [visible]="cadastreDialogVisible"
            [title]="'MATRIKKEL'" [width]="320" [left]="-35" [top]="-102" [arrow]="'none'">
            <div class="tooltip-content">Kommunenr: {{ projectStage()?.kNr || '0' }} - Gnr: {{ projectStage()?.gnr ||
                '0' }} Bnr: {{ projectStage()?.bnr || '0'
                }} Fnr: {{ projectStage()?.fnr || '0' }} Snr: {{ projectStage()?.snr || '0' }}</div>
        </ev_tooltip>
    </div>
    }


    @if(projectStage()?.county != null && projectStage()?.councilId != null) {
    <div class="area-link">
        Kommune <span (click)="navigateToMap(projectStage().councilId, EvAreaType.Municipality)"><span
                class="icon"></span><span>{{ projectStage().kName }}</span> </span>
    </div>
    }
</div>

<div class="links mobile">
    @if(cadastre() != null) {
    <div class="key-value">
        <div class="key">Matrikkel</div>
        <div class="value cadastre">
            <div class="cadastre-info">{{cadastre()}}</div>
            <div class="information-icon" (clickOutside)="cadastreDialogVisible = false"
                (click)="cadastreDialogVisible = !cadastreDialogVisible"></div>

            <ev_tooltip (close)="cadastreDialogVisible = false" [zIndex]="2000" [visible]="cadastreDialogVisible"
                [title]="'MATRIKKEL'" [width]="320" [left]="-35" [top]="-102" [arrow]="'none'">
                <div class="tooltip-content">Kommunenr: {{ projectStage()?.kNr || '0' }} - Gnr: {{ projectStage()?.gnr
                    || '0' }} Bnr: {{ projectStage()?.bnr ||
                    '0'
                    }} Fnr: {{ projectStage()?.fnr || '0' }} Snr: {{ projectStage()?.snr || '0' }}</div>
            </ev_tooltip>
        </div>

    </div>
    }

    @if(projectStage()?.county != null && projectStage()?.councilId != null) {
    <div class="key-value">
        <div class="key">Kommune</div>
        <div class="value area-link uppercase">
            <span (click)="navigateToMap(projectStage().councilId, EvAreaType.Municipality)"><span
                    class="icon"></span><span>{{ projectStage().kName }}</span> </span>
        </div>
    </div>
    }
</div>
}